import CampaignWizard from "./CampaignWizard";
import CampaignWizardFooter from "./CampaignWizardFooter";
import DeliveryWizard from "./DeliveryWizard";
import DeliveryWizardFooter from "./DeliveryWizardFooter";
import { CreateWizardPropsT, WizardTypeE } from "./models";
import { clss } from "../../utils/helpers/styleHelpers";

import styles from './styles.module.scss';

export const useWizardCreator = () => {
    const createWizard = ({ type, mode, deliveryId, campaignDeliveryId }: CreateWizardPropsT) => ({
        header: <></>,
        body: type === WizardTypeE.Campaign ? (
            <CampaignWizard
                mode={mode}
                campaignDeliveryId={campaignDeliveryId}
                type={type}
            />
        ) : (
            <DeliveryWizard
                mode={mode}
                type={type}
                deliveryId={deliveryId}
                campaignDeliveryId={campaignDeliveryId}
            />
        ),
        footer: type === WizardTypeE.Campaign ? (
            <CampaignWizardFooter mode={mode} />
        ) : (
            <DeliveryWizardFooter
                mode={mode}
            />
        ),
        // spec 48 — Tier 2: the modal box carries the entity's identity (bar + tinted title), see styles.
        className: clss([
            styles.wizardPopup,
            type === WizardTypeE.Campaign ? styles.campaignWizard : styles.deliveryWizard,
        ]),
    });

    return createWizard;
};